<template>
  <UiModal
    title="Date de facturare"
    :buttons="buttons"
    @update="update"
    @close="$store.state.layout.billingDetailsModal.active = false"
  >
    <template slot="body">
        <br>
        <UiInput
        label="Țară* (automat)"
        :disabled="true"
        :value="country"
        image="globe.svg"
        />
        <UiInput
        label="Oraș*"
        placeholder="Introduceți numele orașului"
        image="city.svg"
        :value="city"
        :error="errors.city"
        @input="city = $event; validateCity()"
        @blur="validateCity"
        />
        <UiInput
        label="Județ sau regiune"
        placeholder="Introduceți numele județului / regiunii"
        image="diagram.svg"
        :value="county"
        @input="county = $event;"
        />
        <UiInput
        label="Adresă*"
        placeholder="Strada, Bloc, Etaj, etc.."
        image="map-marker.svg"
        :error="errors.address"
        :value="address"
        @input="address = $event; validateAddress()"
        @blur="validateAddress"
        />
        <br>
        <small style="display: block; margin-bottom: 15px;">
                * Aceste informații sunt necesare pentru a emite factura fiscala în cazul unei eventuale achiziții.
        </small>
        <small style="display: block; margin-bottom: 15px;">
                Pentru a emite factură pe firma, adăugați datele SRL-ului în <b>Setări > Date de facturare</b>        
        </small>
        <br>
    </template>
  </UiModal>
</template>
<script>
import UiModal from "@/components/ui/Modal";
import UiButton from "@/components/ui/Button";
import UiInput from "@/components/ui/Input";
import BillingInfoForm from "@/components/forms/Settings/BillingInfo";

import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    UiModal, UiButton, UiInput, BillingInfoForm
  },
  data: function () {
    return {
      buttons: [
          {
              event: 'update',
              text: 'Salvează',
              style: 'gradient',
          }
      ],
      country: '',
      county: '',
      city: '',
      address: '',
      errors: {
        city: '',
        address: '',
      },
    };
  },
  async mounted(){
        if (this.oneMoreStep === false) {
            this.country = this.user.address.country || '';
            this.county = this.user.address.county || '';
            this.city = this.user.address.city || '';
            this.address = this.user.address.address || this.user.address.adress || '';
        }

        await this.fetchCountries({
            defaultCountry: true
        });

        if(this.defaultCountry) this.country = this.defaultCountry;
  },
  watch: {
        "user"(newVal) {
            if (this.oneMoreStep === false) {
                this.country = this.user.address.country || '';
                this.county = this.user.address.county || '';
                this.city = this.user.address.city || '';
                this.address = this.user.address.address || this.user.address.adress || '';
            }
        },
        "defaultCountry"(newVal) {
            this.country = !newVal ? '' : newVal;
        }
  },
  computed: {
        ...mapGetters({
            user: 'user/user',
             defaultCountry: 'settings/defaultCountry'
         }),
        disabledButton() {
            if (
                this.errors.city === ''
                && this.errors.address === ''
                && (
                    this.city.length > 0
                    && this.address.length > 0
                )
            ) {
                return false;
            }

            return true;
        }
  },
  methods: {
        ...mapActions({
            updateBillingInfo: 'settings/updateBillingInfo',
            fetchCountries: 'settings/fetchCountries',
        }),
        validateCity() {
            this.apiError = null;
            this.errors.city = '';

            if(this.city.length < 3 || this.city.length > 60)
                this.errors.city = 'Orașul trebuie să conțină minim 3 și maxim 60 de caractere';
        },
        validateAddress() {
            this.apiError = null;
            this.errors.address = '';

            if(this.address.length < 6 || this.address.length > 220)
                this.errors.address = 'Adresa trebuie să conțină minim 6 si maxim 220 de caractere';
        },
        async update(){
            if(this.country === '') this.country = this.defaultCountry;

            if(this.disabledButton) {
                //Notify
                this.$store.state.notification.notification.icon = null;
                this.$store.state.notification.notification.title = null;
                setTimeout(() => {
                    this.$store.state.notification.notification.icon = "warning";
                    this.$store.state.notification.notification.title = "Asigurați-va că ați completat corect toate câmpurile";
                }, 200);
            }

            const query = {
                    country: this.country,
                    county: this.county,
                    city: this.city,
                    address: this.address,
                };

                await this.updateBillingInfo(query);
                this.$store.state.layout.billingDetailsModal.active = false;
        }
  },
};
</script>

<style lang="scss" scoped>

</style>